import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import {
  CaretDownOutlined,
  InfoCircleOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import SingleMenu from "../../../../components/menu/SingleMenu";
import {
  Draft,
  GroupsExam,
  IndustryOrUniversityProps,
  QuizProps,
  ResultExam,
  ScoreConfigType,
  UserInfoProps,
} from "../../../../types/scoring-course";
import { isEmpty } from "lodash";
import ScoreByGroupItem from "./ScoreByGroupItem";
import { RenderRecordedResults } from "../../../../utils/functionUltils";

interface OverviewProps {
  userInfo?: UserInfoProps;
  quizzes?: QuizProps[];
  result?: ResultExam;
  groups?: GroupsExam[];
  quizzesCompleted?: Draft[];
  showCollapseBtn?: boolean;
  scoreConfig: ScoreConfigType
  totalPoints?: number;
}
function Overview({
  userInfo,
  quizzes,
  result,
  groups,
  showCollapseBtn = true,
  quizzesCompleted = [],
  scoreConfig,
  totalPoints = 0,
}: OverviewProps) {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);

  const totalQuizCompleted = quizzesCompleted?.length;

  const points =
    quizzesCompleted?.reduce((total: number, item: Draft) => {
      return total + item.points;
    }, 0) || 0;

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div
      className={`scoring-overview w-full ${collapsed ? "overview-hidden" : ""
        }`}
    >
      <div className="w-full">
        <div className="over-view-header flex align-center">
          {showCollapseBtn && (
            <Button className="border-none" onClick={toggleCollapsed}>
              {collapsed ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
            </Button>
          )}

          {!collapsed && (
            <div className="flex gap-16">
              <InfoCircleOutlined />
              <span className="font-size-16 font-weight-5">
                {t("Thông tin chung", "Thông tin chung")}
              </span>
            </div>
          )}
        </div>
        {!collapsed && (
          <SingleMenu
            className="overview-menu"
            title={<span className="font-weight-5">{t("Thông tin học viên", "Thông tin học viên")}</span>}
            content={
              <div className="overview-menu-content">
                <Row>
                  <Col span={12}>
                    <span className="font-weight-5">{t("Họ và tên", "Họ và tên")}</span>
                  </Col>
                  <Col span={12}>
                    {isEmpty(userInfo?.lastName) ||
                      isEmpty(userInfo?.firstName) ? (
                      "_"
                    ) : (
                      <span className="one-line">{`${userInfo?.firstName} ${userInfo?.lastName}`}</span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <span className="font-weight-5">Email</span>
                  </Col>
                  <Col span={12}>
                    <span className="one-line">{userInfo?.email || "_"}</span>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <span className="font-weight-5">{t("Trường", "Trường")}</span>
                  </Col>
                  <Col span={12}>
                    {userInfo?.universities &&
                      userInfo?.universities?.length > 0
                      ? userInfo?.universities?.map(
                        (item: IndustryOrUniversityProps, i: number) => (
                          <div key={i} className="one-line">
                            {item.name}
                          </div>
                        )
                      )
                      : "_"}
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <span className="font-weight-5">{t("Chuyên ngành", "Chuyên ngành")}</span>
                  </Col>
                  <Col span={12}>
                    <span className="one-line">
                      {" "}
                      {userInfo?.industries && userInfo?.industries?.length > 0
                        ? userInfo?.industries?.map(
                          (item: IndustryOrUniversityProps, i: number) => (
                            <div key={i} className="one-line">
                              {item.name}
                            </div>
                          )
                        )
                        : "_"}
                    </span>
                  </Col>
                </Row>
              </div>
            }
          />
        )}
        {!collapsed && (
          <SingleMenu
            className="overview-menu"
            title={<span className="font-weight-5">{t("Thông tin bài chấm", "Thông tin bài chấm")}</span>}
            content={
              <div className="overview-menu-content">
                <Row>
                  <Col span={12}>
                    <span className="font-weight-5">{t("Đã chấm", "Đã chấm")}</span>
                  </Col>
                  <Col span={12}>
                    <span className="one-line font-weight-5">
                      {totalQuizCompleted}/{quizzes?.length} {t("câu", "câu")}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <SingleMenu
                    expendIcon={<CaretDownOutlined />}
                    className="total-point-detail"
                    title={
                      <Row>
                        <Col span={12}>
                          <span className="font-weight-5">{t("Tổng điểm", "Tổng điểm")}</span>
                        </Col>
                        <Col span={12}>
                          <span className="font-weight-5">
                            {points}/{totalPoints} {t("điểm", "điểm")}
                          </span>
                        </Col>
                      </Row>
                    }
                    content={
                      <div>
                        {groups?.map((item: GroupsExam, i) => (
                          <ScoreByGroupItem
                            key={i}
                            group={item}
                            quizzesCompleted={quizzesCompleted}
                          />
                        ))}
                      </div>
                    }
                  />
                </Row>
              </div>
            }
          />
        )}

        <div className="description">
          <div className="txt">
            <span className="title">{t("Kết quả ghi nhận:", "Kết quả ghi nhận:")} </span>
            {scoreConfig?.recordResult ? RenderRecordedResults(scoreConfig.recordResult) : '-'}
          </div>
          <div className="txt">
            <span className="title">{t("Điểm tối thiểu:", "Điểm tối thiểu:")} </span>
            {scoreConfig?.courseScore ?? '-'}
          </div>
          <div className="txt">
            <span className="title">{t("Bắt buộc:", "Bắt buộc:")} </span>
            {scoreConfig?.requireToComplete === 1 ? t("Có", "Có") : t("Không", "Không")}
          </div>
          <div className="txt">
            <span className="title">{t("Số lần được phép làm lại tối đa:", "Số lần được phép làm lại tối đa:")} </span>
            {scoreConfig?.numberActionEvaluate ?? '-'}
          </div>
          <div className="txt">
            <span className="title">{t("Hình thức đánh giá:", "Hình thức đánh giá:")} </span>
            {scoreConfig?.formOfReview === 1 ? t("Trực tuyến", "Trực tuyến") : t("Trực tiếp", "Trực tiếp")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Overview;
